import { TableFilter } from 'root/apps/PurchaseOrder/NuorderOrdering/types';

export const applyFilters = <T>(
  searchableKeys: (keyof T)[],
  searchTerm: string,
  filters: TableFilter<T>[],
  data: T[]
): T[] => {
  let filteredData = [...data];
  if (filters.length > 0) {
    filteredData = filteredData.filter((row) => {
      return filters.every((filter) => {
        return filter.values.includes(row[filter.key]);
      });
    });
  }
  if (searchTerm) {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    filteredData = filteredData.filter((row) =>
      searchableKeys.some((key) => {
        const value = row[key];
        return typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchTerm);
      })
    );
  }
  return filteredData;
};

export const applySort = <T extends { id: number }>(
  sortKey: keyof T,
  sortDirection: 'asc' | 'desc' | 'unsorted',
  data: T[]
): T[] => {
  const sortedRows = [...data];

  switch (sortDirection) {
    case 'asc':
      sortedRows.sort((a, b) => {
        const valA = a[sortKey];
        const valB = b[sortKey];
        if (typeof valA === typeof valB) {
          if (valA < valB) return -1;
          if (valA > valB) return 1;
          return 0;
        }
        return typeof valA === 'number' ? -1 : 1;
      });
      break;
    case 'desc':
      sortedRows.sort((a, b) => {
        const valA = a[sortKey];
        const valB = b[sortKey];
        if (typeof valA === typeof valB) {
          if (valA > valB) return -1;
          if (valA < valB) return 1;
          return 0;
        }
        return typeof valA === 'number' ? 1 : -1;
      });
      break;
    case 'unsorted':
    default:
      sortedRows.sort((a, b) => (a.id < b.id ? -1 : 1));
  }
  return sortedRows;
};
